import React, { useRef, useEffect } from 'react'
import classNames from 'classnames';
import { ChatMessageEvent, IChatMessage } from 'store/messages/messages.state';
import { capitaliseString, getOS } from '../../utils/index'


import './meta-message.scss';
import useApp from 'hooks/useApp';
import { DEFAULT_LANGUAGE, Translations } from 'translations';

export const getMetaString = (msg: IChatMessage, translations: Translations | null, language: string) => {    
    const customer = translations?.metaMessages?.[language]?.CUSTOMER ?? translations?.metaMessages?.[DEFAULT_LANGUAGE]?.CUSTOMER;
    const agent = translations?.metaMessages?.[language]?.AGENT ?? translations?.metaMessages?.[DEFAULT_LANGUAGE]?.AGENT;
    const leftTheChat = translations?.metaMessages?.[language]?.leftTheChat ?? translations?.metaMessages?.[DEFAULT_LANGUAGE]?.leftTheChat;
    const joinedTheChat = translations?.metaMessages?.[language]?.joinedTheChat ?? translations?.metaMessages?.[DEFAULT_LANGUAGE]?.joinedTheChat;
    const chatEnded = translations?.metaMessages?.[language]?.chatEnded ?? translations?.metaMessages?.[DEFAULT_LANGUAGE]?.chatEnded;
    const chatTransferredSuccesfully = translations?.metaMessages?.[language]?.chatTransferredSuccesfully ?? translations?.metaMessages?.[DEFAULT_LANGUAGE]?.chatTransferredSuccesfully;
    const chatTransferFailed = translations?.metaMessages?.[language]?.chatTransferFailed ?? translations?.metaMessages?.[DEFAULT_LANGUAGE]?.chatTransferFailed;

    const name = msg.displayName || (msg.role === "CUSTOMER" ? customer : agent)
    switch (msg.contentType) {
        case ChatMessageEvent.PARTICIPANT_LEFT:
            return `${name} ${leftTheChat}`;
        case ChatMessageEvent.PARTICIPANT_JOINED:
            return `${name} ${joinedTheChat}`;
        case ChatMessageEvent.CHAT_ENDED:
            return chatEnded;
        case ChatMessageEvent.TRANSFER_SUCCESS:
            return chatTransferredSuccesfully;
        case ChatMessageEvent.TRANSFER_FAILURE:
            return chatTransferFailed;
        default:
            console.warn("Unknown message type, displaying content...")
            return msg.contentType;
    }
}



const MetaChatMessage: React.FC<IChatMessage> = ({ contentType, displayName, role, content }) => {
    const classes = classNames({
        'sa-chat-message-meta': true,
    })

    useEffect(() => {
        if (getOS() === 'Win') {
            setTimeout(() => {
                systemMessage?.current?.focus()
            }, 3500);
        }
    }, [contentType])


    const { language, appTextTranslations } = useApp();
    const translatedRole =
        //@ts-ignore
        appTextTranslations?.metaMessages?.[language]?.[displayName?.toLocaleUpperCase()] ??
        appTextTranslations?.metaMessages?.[language]?.[role] ??
        capitaliseString(role?.toLocaleLowerCase() ?? '');
    const participantName = translatedRole
    const systemMessage = useRef<HTMLParagraphElement>(null);

    const translatedMessages = {
        leftChat: appTextTranslations?.metaMessages?.[language]?.leftTheChat ?? appTextTranslations?.metaMessages?.[DEFAULT_LANGUAGE]?.leftTheChat,
        joinedChat:
            appTextTranslations?.metaMessages?.[language]?.joinedTheChat ?? appTextTranslations?.metaMessages?.[DEFAULT_LANGUAGE]?.joinedTheChat,
        chatEnded: appTextTranslations?.metaMessages?.[language]?.chatEnded ?? appTextTranslations?.metaMessages?.[DEFAULT_LANGUAGE]?.chatEnded,
        transferSuccess:
            appTextTranslations?.metaMessages?.[language]?.chatTransferredSuccesfully ??
            appTextTranslations?.metaMessages?.[DEFAULT_LANGUAGE]?.chatTransferredSuccesfully,
        transferFail:
            appTextTranslations?.metaMessages?.[language]?.chatTransferFailed ??
            appTextTranslations?.metaMessages?.[DEFAULT_LANGUAGE]?.chatTransferFailed,
    };

    const getContentByType = () => {
        switch (contentType) {
            case ChatMessageEvent.PARTICIPANT_LEFT:
                return `${participantName} ${translatedMessages.leftChat}`;
            case ChatMessageEvent.PARTICIPANT_JOINED:
                return `${participantName} ${translatedMessages.joinedChat}`;
            case ChatMessageEvent.CHAT_ENDED:
                return translatedMessages.chatEnded;
            // case ChatMessageEvent.CHAT_STARTED:
            //     return `Chat Started`
            case ChatMessageEvent.TRANSFER_SUCCESS:
                return translatedMessages.transferSuccess
            case ChatMessageEvent.TRANSFER_FAILURE:
                return translatedMessages.transferFail
            default:
                console.warn("Unknown message type, displaying content...")
                return content ?? contentType;
        }
    }
    const getContent = () => (content || getContentByType()) as string

    return (
        <div
            className={classes}
            role="status"
        >
            {
                <p ref={systemMessage}>
                    {getContent()}
                </p>
            }

        </div>
    )
}

export default MetaChatMessage
